import { render } from "./UserLoginForm.vue?vue&type=template&id=97877a32&scoped=true"
import script from "./UserLoginForm.vue?vue&type=script&lang=js"
export * from "./UserLoginForm.vue?vue&type=script&lang=js"

import "./UserLoginForm.vue?vue&type=style&index=0&id=97877a32&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97877a32"]])

export default __exports__